import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { loadGroups } from '../../common/groups/actions'
import { updateMe } from '../../common/users/actions'
import { GroupsList, PageHeader, Popup } from '../components'


class GroupsPage extends React.Component {
  componentDidMount() {
    const { groups, loadGroups } = this.props
    if (!groups.size) loadGroups()
  }

  render() {
    const { viewer, updateMe, groups, intl } = this.props

    return (
      <div>
        <PageHeader
          title={intl.formatMessage(messages.classes)}
          button={{
            link: '/app/create-group',
            text: intl.formatMessage(messages.createClass),
          }}
        />
        <GroupsList groups={groups} />
      </div>
    )
  }
}

GroupsPage.defaultProps = {
  groups: [],
}

GroupsPage.propTypes = {
  intl: PropTypes.object.isRequired,
  loadGroups: PropTypes.func.isRequired,
  viewer: PropTypes.object.isRequired,
  groups: PropTypes.array,
  updateMe: PropTypes.func.isRequired,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    groups: state.groups.all,
  }), { loadGroups, updateMe }),
  injectIntl,
)

export default enhance(GroupsPage)

const messages = defineMessages({
  classes: {
    id: 'groupForm.page.classes',
    defaultMessage: 'Triedy',
  },
  createClass: {
    id: 'groups.page.createClass',
    defaultMessage: 'Vytvoriť triedu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/GroupsPage.js